import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject, Subject } from "rxjs";
import {
    MatDialogRef,
    MatDialog,
    MatDialogConfig,
} from "@angular/material/dialog";
import { ToastaService, ToastaConfig, ToastOptions } from "ngx-toasta";
import "rxjs/Rx";
import { ReviewPopupComponent } from "../Global/ReviewPopup/ReviewPopup.component";
import { ConfirmationPopupComponent } from "../Global/ConfirmationPopup/ConfirmationPopup.component";
import { environment } from "../../environments/environment.prod";
import { AuthService } from "./auth.service";
import { CheckoutService } from "./checkout.service";
import { ProductsService } from "./product.service";

import { AccountSettingService } from "./account-setting.service";
import Swal from "sweetalert2";
import { MarketingService } from "./marketing.service";
import { StaticPagesService } from "./static-pages.service";
interface Response {
    data: any;
}
@Injectable()
export class EmbryoService {



    loyaltyPoints: BehaviorSubject<any> = new BehaviorSubject(null);
    walletObs: BehaviorSubject<any> = new BehaviorSubject(null);
    productCartSub: BehaviorSubject<any> = new BehaviorSubject([]);
    productCartStatusCode: BehaviorSubject<any> = new BehaviorSubject([]);
    setProductParentId: BehaviorSubject<any> = new BehaviorSubject([]);
    productGifts: BehaviorSubject<any> = new BehaviorSubject(
        JSON.parse(<string>localStorage.getItem("gifts")) || []
    );
    productSuggestions: BehaviorSubject<any> = new BehaviorSubject(
        JSON.parse(<string>localStorage.getItem("suggestions")) || []
    );
    compareListSub = new BehaviorSubject(
        JSON.parse(<string>localStorage.getItem("compareItems")) || []
    );
    unCompareProductSub = new BehaviorSubject({});
    multiInventoryMap = new BehaviorSubject({});
    favouritesListSub = new BehaviorSubject(
        JSON.parse(<string>localStorage.getItem("wishListItems")) || []
    );
    private freeDelivery: BehaviorSubject<string> = new BehaviorSubject<string>(
        "Initial Value"
    );
    data: Observable<string> = this.freeDelivery.asObservable();

    private checkoutNotes: BehaviorSubject<string> =
        new BehaviorSubject<string>("Initial Value");

    checkOutNotesData: Observable<any> = this.checkoutNotes.asObservable();

    private exclusive_prom_stats: Subject<boolean> = new Subject<boolean>();
    exclusivePromcodeStats: Observable<boolean> =
        this.exclusive_prom_stats.asObservable();

    public brandsList: Subject<boolean> = new Subject<boolean>();
    sendBrandsListData: Observable<boolean> = this.brandsList.asObservable();

    public rateData: Subject<boolean> = new Subject<boolean>();
    RateData: Observable<boolean> = this.rateData.asObservable();
    
    public categoriesMenu: Subject<boolean> = new Subject<boolean>();
    CategoriesMenu: Observable<boolean> = this.categoriesMenu.asObservable();

    private setFlagToAddPromoCodeButton: Subject<boolean> =
        new Subject<boolean>();
    clearLodaerFromAddPromoCodeButton: Observable<boolean> =
        this.setFlagToAddPromoCodeButton.asObservable();

     public totalPrice: Subject<boolean> = new Subject<boolean>();
         setTotalPrice: Observable<boolean> = this.totalPrice.asObservable();

     public redeemStatus: Subject<boolean> = new Subject<boolean>();
         setredeemStatus: Observable<boolean> = this.redeemStatus.asObservable();

     public PurchaseFees: Subject<boolean> = new Subject<boolean>();
         PurchaseFeesValue: Observable<boolean> = this.PurchaseFees.asObservable();

     public isPaymentPage: Subject<boolean> = new Subject<boolean>();
         setPaymentPageStatus: Observable<boolean> = this.isPaymentPage.asObservable();

     public postpondPaymentValue: Subject<boolean> = new Subject<boolean>();
         setPostpondPaymentValue: Observable<boolean> = this.postpondPaymentValue.asObservable();

     public DueAmountInSideTotalPayment: Subject<boolean> = new Subject<boolean>();
         setDueAmountInSideTotalPaymentStatus: Observable<boolean> = this.DueAmountInSideTotalPayment.asObservable();

    notificationsListSub = new BehaviorSubject({});
    url;
    sidenavOpen: boolean = false;
    paymentSidenavOpen: boolean = false;
    isDirectionRtl: boolean = false;
    promoObject: any;
    deliveryFees: any;
    checkout_notes: string = "";
    checkout_notes_ar: string = "";
    featuredProductsSelectedTab: any = 0;
    newArrivalSelectedTab: any = 0;
    compareCount: any;
    refreshProductWishlist: EventEmitter<EmbryoService>;
    currency: string = "LE";
    language: string = "en";
    lang: string = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : "en";
    emitLang = new BehaviorSubject(this.lang);
    shipping: number = 12.95;
    tax: number = 27.95;
    index: any;
    toastOption: ToastOptions = new ToastOptions();
    localStorageCartProducts: any;
    localStorageWishlist: any;
    navbarCartCount: number = 0;
    navbarWishlistProdCount = 0;
    buyUserCartProducts: any;
    products: any[] = [];
    showScrollButton: boolean = false;
    showScrollButton2: boolean = false;
    guestProductsCart: any = [];
    guestProductsCompare: any = localStorage.getItem("compareItems")
        ? JSON.parse(<string>localStorage.getItem("compareItems"))
        : [];
    environmentVariables: any;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private toastyService: ToastaService,
        private toastyConfig: ToastaConfig,
        private auth: AuthService,
        private checkoutService: CheckoutService,
        private productService: ProductsService,
        private account: AccountSettingService,
        private marketingService: MarketingService,
        private confgServ: StaticPagesService,

    ) {
        this.productCartSub.subscribe((res) => {
            this.products = res;
            this.guestProductsCart = res;
        });
        this.refreshProductWishlist = new EventEmitter();
        this.url = environment.api + "/api/customer/";
        this.toastyConfig.position = "top-right";
        this.toastyConfig.theme = "material";
        localStorage.removeItem("user");
        this.lang = localStorage.getItem("lang") || "en";

        this.favouritesListSub.subscribe((products) => {
            if (this.auth && this.auth.isGuest()) {
                localStorage.setItem("wishListItems", JSON.stringify(products));
            }
        });

        let wishListItems = JSON.parse(
            <string>localStorage.getItem("wishListItems")
        );
        if (wishListItems && wishListItems.length) {
            this.favouritesListSub.next(wishListItems);
        }

        if (this.products && this.products.length) {
            this.productCartSub.next(this.products);
        }
        this.getInitilizingData();

    }

        getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
        });
    }
    setWalletDataEmit(data: any) {
        this.walletObs.next(data);
    }
    getWalletDataEmit(): Observable<any> {
        return this.walletObs.asObservable();
    }
    setLoyaltyDataEmit(data: any) {
        this.loyaltyPoints.next(data);
    }
    getLoyaltyDataEmit(): Observable<any> {
        return this.loyaltyPoints.asObservable();
    }
    sendFreeDeliveryStatus(data: any) {
        this.freeDelivery.next(data);
    }
    getLoyalty() {
        return this.http.get(
            `${environment.api}/api/customer/profile/loyalty_points`
        );
    }

    checkoutNotesData(data: string) {
        this.checkoutNotes.next(data);
    }

    sendPromcodeStatusData(data: boolean) {
        this.exclusive_prom_stats.next(data);
    }

    sendBrands(data: any) {
        this.brandsList.next(data);
    }
    sendTotalPrice(data: any) {
        this.totalPrice.next(data);
    }
    sendRedeemStatus(data: any) {
        this.redeemStatus.next(data);
    }
    sendPurchaseFees(data: any) {
        this.PurchaseFees.next(data);
    }
    sendPaymentPAgeStatus(data: any) {
        this.isPaymentPage.next(data);
    }
    sendPostpondPaymentValue(data:any) {
        this.postpondPaymentValue.next(data);
    }

    sendDueAmountInSideTotalPayment(data:any) {
        this.DueAmountInSideTotalPayment.next(data);
    }

    sendRateData(data: any) {
        this.rateData.next(data);
    }
    setCategoriesMenu(data: any) {
        this.categoriesMenu.next(data);
    }

    sendFlagToAddPromocodeButton(data: boolean) {
        this.setFlagToAddPromoCodeButton.next(data);
    }

    setCartItemDefaultValue(setCartItemDefaultValue: any) {
        this.productCartSub.subscribe((res) => (this.products = res));
        let found = this.products.some((el: any) => {
            if (el.name == setCartItemDefaultValue.name) {
                return true;
            } else {
                return false;
            }
        });
        if (!found) {
            this.products.push(setCartItemDefaultValue);
        }
        this.productCartSub.next(this.products);
    }

    reviewPopup(singleProductDetails: any, reviews: any) {
        let review: MatDialogRef<ReviewPopupComponent>;
        const dialogConfig = new MatDialogConfig();
        if (this.isDirectionRtl) {
            dialogConfig.direction = "rtl";
        } else {
            dialogConfig.direction = "ltr";
        }

        review = this.dialog.open(ReviewPopupComponent, dialogConfig);
        review.componentInstance.singleProductDetails = singleProductDetails;
        review.componentInstance.reviews = reviews;

        return review.afterClosed();
    }

    confirmationPopup(message: string) {
        let confirmationPopup: MatDialogRef<ConfirmationPopupComponent>;
        confirmationPopup = this.dialog.open(ConfirmationPopupComponent, {
            data: message,
        });
        confirmationPopup.componentInstance.message = message;

        return confirmationPopup.afterClosed();
    }

    AddCartFullObject(data: any, showToastr = true) {
        let toastOption = {
            title: "Product added to cart",
            msg: "Product added to the cart",
            timeout: 3000,
            progressAnimation: "increasing",
            positionClass: "toast-bottom-right",
        };

        this.lang = localStorage.getItem("lang") || "en";

        if (this.lang == "ar") {
            toastOption.title = "تمت إضافة المنتج للسلة";
            toastOption.msg =
                "لقد قمت بالفعل بإضافة هذا المنتج إلى قائمة السلة";
        }

        if (showToastr) {
            Swal.fire({
                title: toastOption.title,
                html: `<p style='color:white'>${toastOption.msg}</p>`,
                width: 250,
                position: "bottom-end",
                background: "#51A351",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }

        this.productCartSub.next(data);
        this.navbarCartCount = data.length;
    }

    productAlreadyAdded() {
        let toastOption: ToastOptions = {
            title: "Adding product to cart",
            msg: "Product adding to the cart",
            showClose: true,
            timeout: 3000,
            theme: "material",
        };
        if (this.lang == "en") {
            toastOption.title = "Product already added";
            toastOption.msg =
                "You have already added this product to cart list";
        } else {
            toastOption.title = "تمت إضافة المنتج بالفعل";
            toastOption.msg =
                "لقد قمت بالفعل بإضافة هذا المنتج إلى قائمة السلة";
        }
    }

    buyNow(data: any) {
        this.productCartSub.subscribe((res) => (this.products = res));

        let found = this.products.some((el, index) => {
            if (el.id == data.id) {
                if (!data.quantity) {
                    data.quantity = 1;
                }
                this.products[index]["quantity"] = data.quantity;
                return true;
            } else {
                return false;
            }
        });
        if (!found) {
            this.products.push(data);
        }

        this.productCartSub.next(this.products);
    }

    updateAllLocalCartProduct(products: any) {
        this.productCartSub.next(products);
        this.getProductCart();
    }

    removeLocalCartProduct(product: any) {
        this.productCartSub.subscribe((res) => (this.products = res));

        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].id === product.id) {
                this.products.splice(i, 1);
                break;
            }
        }

        let toastOption: ToastOptions = {
            title: "Remove product from Cart",
            msg: "Product removing from cart",
            showClose: true,
            timeout: 500,
            theme: "material",
        };

        this.lang = localStorage.getItem("lang") || "en";
        if (this.lang == "ar") {
            toastOption.title = "ازالة المنتج من العربة";
            toastOption.msg = "يتم الان ازالة المنتج من العربة";
        }

        this.toastyService.wait(toastOption);
        setTimeout(() => {
            // ReAdding the products after remove
            this.productCartSub.next(this.products);
        }, 500);
        this.getProductCart();
    }

    addToWishlist(data: any) {
        this.localStorageWishlist = this.favouritesListSub.subscribe((res) => {
            return res;
        });

        const indexProduct = this.localStorageWishlist.findIndex(
            (item: any) => item.name == data.name
        );
        if (indexProduct == -1) {
            if (!data.quantity) data.quantity = 1;

            this.localStorageWishlist.push(data);
            this.toastOption = {
                title: "Adding product to wishlist",
                msg: "Product adding to the wishlist",
                showClose: true,
                timeout: 3000,
                theme: "material",
            };
            this.lang = localStorage.getItem("lang") || "en";
            if (this.lang == "ar") {
                this.toastOption.title = "تمت إضافة المنتج لقائمة المفضلة";
                this.toastOption.msg =
                    "لقد قمت بالفعل بإضافة هذا المنتج إلى قائمة المفضلة";
            }
            this.toastyService.wait(this.toastOption);
            setTimeout(() => {
                this.favouritesListSub.next(this.localStorageWishlist);
                this.calculateLocalWishlistProdCounts();
            }, 500);
        } else {
            this.localStorageWishlist.splice(indexProduct, 1);
            this.toastOption = {
                title: "Remove product from wishlist",
                msg: "Product remove form the wishlist",
                showClose: true,
                timeout: 3000,
                theme: "material",
            };
            this.lang = localStorage.getItem("lang") || "en";
            if (this.lang == "ar") {
                this.toastOption.title = "تم ازالة المنتج من قائمة المفضلة";
                this.toastOption.msg =
                    "لقد قمت بالفعل بازالة هذا المنتج من قائمة المفضلة";
            }
            this.toastyService.wait(this.toastOption);
            setTimeout(() => {
                this.favouritesListSub.next(this.localStorageWishlist);
                this.calculateLocalWishlistProdCounts();
            }, 500);
        }
    }

    calculateLocalWishlistProdCounts() {
        this.localStorageWishlist = null;
        this.localStorageWishlist = this.favouritesListSub.subscribe(
            (res) => res
        );
        this.navbarWishlistProdCount = +this.localStorageWishlist.length;
    }

    removeLocalWishlistProduct(product: any) {
        this.localStorageWishlist = this.favouritesListSub.subscribe(
            (res) => res
        );

        for (let i = 0; i < this.localStorageWishlist.length; i++) {
            if (this.localStorageWishlist[i].id === product.id) {
                this.localStorageWishlist.splice(i, 1);
                break;
            }
        }

        const toastOption: ToastOptions = {
            title: "Remove product from wishlist",
            msg: "Product removing from wishlist",

            showClose: true,
            timeout: 500,
            theme: "material",
        };
        if (this.lang == "en") {
            toastOption.title = "Remove product from wishlis";
            toastOption.msg = "Product removing from wishlist";
        } else {
            toastOption.title = "تتم الان ازالة المنتج من المفضلة";
            toastOption.msg = "لقد قمت بازالة   هذا المنتج إلى قائمة المفضلة";
        }

        this.toastyService.wait(toastOption);
        setTimeout(() => {
            this.favouritesListSub.next(this.localStorageWishlist);
            this.refreshProductWishlist.emit(this.localStorageWishlist);
            this.calculateLocalWishlistProdCounts();
        }, 500);
        this.getProductCart();
    }

    addAllWishListToCart(dataArray: any) {
        this.productCartSub.subscribe((res) => (this.products = res));

        for (let singleData of dataArray) {
            this.products.push(singleData);
        }

        let toastOption: ToastOptions = {
            title: "Adding all product to cart",
            msg: "Products adding to the cart",
            showClose: true,
            timeout: 500,
            theme: "material",
        };

        this.toastyService.wait(toastOption);
        setTimeout(() => {
            localStorage.removeItem("wishlist_item");
            this.productCartSub.next(this.products);
            this.calculateLocalWishlistProdCounts();
        }, 500);
        this.getProductCart();
    }

    addBuyUserDetails(formdata: any) {
        localStorage.setItem("user", JSON.stringify(formdata));
        this.productCartSub.subscribe((res) => (this.products = res));
        this.buyUserCartProducts = this.products;
        this.productCartSub.next([]);
    }

    removeBuyProducts() {
        this.buyUserCartProducts = this.products;
    }

    Emitlanguage(data: any) {
        this.emitLang.next(data);
        this.lang = data;
    }

    getProductCart() {
        this.productCartSub.subscribe((res) => (this.products = res));
        if (this.products) this.productCartSub.next(this.products);
    }

    setCompareCount(productCount: any) {
        this.compareListSub.next(productCount);
        this.compareCount = productCount;
    }

    getCompareCount() {
        return this.compareCount;
    }

    updateItemApi(product: any) {
        this.productCartSub.subscribe((res) => (this.products = res));
        const index = this.products.findIndex((item) => item.id == product.id);
        if (index !== -1) this.products[index] = product;
        this.store(this.products);
    }

    store(products: any) {
        this.productCartSub.next(products);
        this.getProductCart();
    }

    PostRequestById(url: any, id: number, data: any) {
        return this.http.post(`${this.url}${url}/${id}`, data);
    }

    isInProductsFoundBefore(
        product: any,
        guestList = this.guestProductsCompare
    ) {
        if (guestList)
            return guestList.some((item: any) => item.id == product.id);
    }

    // Guest user type (Cart)
    removeFromCart(product: any, index: any) {
        this.guestProductsCart.splice(index, 1);
        this.productCartSub.next(this.guestProductsCart);
    }

    validateCart() {
        if (this.guestProductsCart) {
            return this.checkoutService.validateCart({
                items: this.guestProductsCart,
            });
        } else {
            return this.checkoutService.validateCart({ items: [] });
        }
    }

    addToCartGuest(product: any, type = null, amount = null) {
        this.marketingService.fbTracking("track", "AddToCart", {
            content_ids: [product.sku],
            content_type: "product",
            content_name: product.name,
            value: product.discount_price
                ? product.discount_price
                : product.price,
            contents: [{ id: product.sku, quantity: product.amount }],
            currency:  this.environmentVariables?.CURRENCY_CODE_EN,
        });
           this.marketingService.snapTracking("track", 'ADD_CART', {
              item_ids: [product.sku],
              number_items: product.amount,
              price: product.discount_price
                  ? product.discount_price
                  : product.price,
              currency: this.environmentVariables?.CURRENCY_CODE_EN,
            });

           
        let obj = {
            item_name: product.name,
            item_id: product.id,
            active: product.active,
            price: product.discount_price
                ? product.discount_price
                : product.price,
            item_brand:
                product.details && product.details.brand
                    ? product.details.brand.name
                    : "",
            item_category: product.category ? product.category.name : "-",
            item_category2: product.category
                ? product.category.sub_categories
                    ? product.category.sub_categories[0].name
                    : "-"
                : "-",
            item_list_name: product.actegory ? product.actegory.id : "",
            item_list_id: product.actegory ? product.actegory.name : "",
            index: "",
            quantity: product.amount,
        };
        let result = {
            event: "add_to_cart",
            ecommerce: {
                currency:  this.environmentVariables?.CURRENCY_CODE_EN,
                value: product.discount_price
                    ? product.discount_price
                    : product.price,
                items: obj,
                extras: this.account.googleAnalaticsUserData,
            },
        };
        
        if (this.auth.isGuest()) {
            if (product.in_stock && product.amount <= product.stock) {
                if (amount !== null) {
                    product.amount = amount;
                } else if (amount === null && type === 0) {
                    product.amount = product.amount ? product.amount : null;
                } else {
                    product.amount = product.amount ? product.amount : 1;
                }
                if (this.guestProductsCart) {
                    if (product.amount == null) {
                        // check if amount equal naull in cart remove it
                        let indexProduct = this.guestProductsCart.findIndex(
                            (item: any) => {
                                return item.id == product.id;
                            }
                        );
                        this.guestProductsCart.splice(indexProduct, 1);
                    } else {
                        if (
                            !this.isInProductsFoundBefore(
                                product,
                                this.guestProductsCart
                            )
                        ) {
                            this.guestProductsCart = [
                                ...this.guestProductsCart,
                                product,
                            ];
                        } else {
                            let selectedIndex;
                            selectedIndex = this.guestProductsCart.findIndex(
                                (item: any) => {
                                    return item.id == product.id;
                                }
                            );
                            this.guestProductsCart[selectedIndex].amount =
                                product.amount;
                        }
                    }
                } else {
                    this.guestProductsCart.push(product);
                }

                this.productCartSub.next(this.guestProductsCart);
            } else if (product.available_soon) {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Ops This product is available soon"
                            : "هذا سيتوفر قريبا"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            } else {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Ops This product is out of stock"
                            : "  نفد هذا المنتج من المخازن"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
        }
    }

    // Guest user type (Compare)
    addToCompare(product: any) {
        if (!this.isInProductsFoundBefore(product)) {
            this.productService
                .getComparedProductById(product.id)
                .subscribe((res: any) => {
                    if (res.code === 200) {
                        this.guestProductsCompare.push(res.data.product);
                        if (this.auth.isGuest()) {
                            localStorage.setItem(
                                "compareItems",
                                JSON.stringify(this.guestProductsCompare)
                            );
                        }
                        this.compareListSub.next(this.guestProductsCompare);
                        Swal.fire({
                            html: `<p style='color:white'>${
                                this.lang === "en"
                                    ? "Product added to compare successfully."
                                    : "تم اضافة المنتج الي المقارنة"
                            }</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#51A351",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    }
                });
        }
    }

    removeProductFromCompareGuest(product: any) {
        if (this.auth.isGuest() && this.isInProductsFoundBefore(product)) {
            this.guestProductsCompare = this.guestProductsCompare.filter(
                (item: any) => item.id !== product.id
            );
            localStorage.setItem(
                "compareItems",
                JSON.stringify(this.guestProductsCompare)
            );
            this.compareListSub.next(this.guestProductsCompare);
            Swal.fire({
                html: `<p style='color:white'>${
                    this.lang === "en"
                        ? "Product removed from compare successfully."
                        : "تم مسج المنتج من المقارنة"
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#51A351",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }
    }

    RateOrderAndDriver(data: any, order_id: number) {
        return this.http.post<any>(
            `${environment.api}/api/customer/orders/rate/${order_id}`,
            data
        );
    }


    RateProduct(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/products/review`,
            data
        );
    }
}
